<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Card Payouts: Fast & Simple</div>
            <div class="banner_tips mt-40 fw-300">Settle payments to suppliers, wallet holders, or creators with fast, reliable card payout infrastructure.</div>
             <router-link to="contact-us"><span class=" pointer color1 py-10 px-20 border-default mt-20 fs-f20 bg_3 dis-i-b" >Get Started</span></router-link>
          </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Streamlined B2C Payouts</div>
            <div class="title_tag color1">Simplify mass payouts to individuals. Pay suppliers, marketplace users, or creators quickly and efficiently.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb12.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Industry Insight</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">We partner with merchants and card acquirers to solve B2C and C2B cash flow challenges.</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb13.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Expert Solutions</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Leverage our expertise in global card payments to deliver tailored payout solutions.</div>
                    </div>
                </div>
               
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Global Reach, Local Precision</div>
            <div class="title_tag color1">Worldwide coverage with support for local payment preferences.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon mb-10">
                          <div class="flex">
                            <div class="flex_item" v-for="(i,index) in gjList" :key="index"><img :src="i.icon" alt=""></div>
                            <div class="flex_item fs-12 color1 flex_center">55+</div>
                          </div>
                        </div>
                        <div class="half_title color1">55+ Countries</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">High approval rates in regions like North America, Europe, Asia, and more.</div>
                    </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon mb-10">
                         <div class="flex">
                            <div class="flex_item" v-for="(i,index) in zfList" :key="index"><img :src="i.icon" alt=""></div>
                            <div class="flex_item fs-12 color1 flex_center">100+</div>
                          </div>
                        </div>
                        <div class="half_title color1">100+ Currencies</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Accept payments in global currencies to expand your market.</div>
                    </div>
                </div>
                
              </div>
          </div>
        </div>
      </div>
    </div>
     <div class="container">
      <div class="page_title_bg pt-60 pb-60" >
        <div class="page_width " >
           <div class="page_title">
            <div class="title_name color1">Instant Funds Delivery</div>
            <div class="title_tag color1">Real-time payouts via global and localized card payment routes.</div>
          </div>
          <div class="grid mt-60 grid_md_gap">
            <div class="grid_md_6 grid_xs_12 grid_sm_12">
              <div class="flex_col_center py-20">
                <img src="../../assets/image/dz7.png" alt="" class="h-84px w-a">
                <div class="fs-30 mt-20 color1 fw-300">Deliver funds instantly with AI-driven routing.</div>
              </div>
            </div>
            <div class="grid_md_6 grid_xs_12 grid_sm_12">
              <div class="flex_col_center py-20">
                <img src="../../assets/image/dz8.png" alt=""  class="h-84px w-a">
                <div class="fs-30 mt-20 color1 fw-300">Simplified settlement for quick, hassle-free payouts.</div>
              </div>
            </div>
           
          </div>
        </div>
      </div>
     
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Pay Out Using Your Pay-In Balance</div>
            <div class="title_tag color1">Use existing pay-in balance for payouts. Reduce costs and cash flow gaps.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb14.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Cost-Effective</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Eliminate extra bank transfers by using available funds.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb15.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Balance Netting</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Maintain healthy cash flow with seamless transfers.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb16.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Instant Availability</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Access and distribute funds instantly.</div>
                    </div>
                </div>
               
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color1">Automated Payout Validation</div>
            <div class="title_tag color1">Automated review and validation for fast, accurate, secure payouts.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb17.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Accurate</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Automated checks minimize errors.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb18.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Efficient</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Fast processing eliminates delays.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-card p-20 card_bg h-100p">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb19.png" alt="" class="">
                        </div>
                        <div class="half_title color1">Unified Dashboard</div>
                        <div class="half_text color1 mt-10 fs-14 fw-300">Verifies critical details to protect merchants and payees.</div>
                    </div>
                </div>
               
              </div>
          </div>
        </div>
      </div>
    </div>




  </div>
</template>
 
<script>

import icon1 from '../../assets/image/zftb1.png'
import icon2 from '../../assets/image/zftb2.png'
import icon3 from '../../assets/image/zftb3.png'
import icon4 from '../../assets/image/zftb4.png'
import icon5 from '../../assets/image/zftb5.png'


import gj1 from '../../assets/image/gj1.png'
import gj2 from '../../assets/image/gj2.png'
import gj3 from '../../assets/image/gj3.png'
import gj4 from '../../assets/image/gj4.png'
import gj5 from '../../assets/image/gj5.png'


export default {
 
    data(){
        return{
           tab_active:'1', 
        
           zfList:[
            {icon:icon1},{icon:icon2},{icon:icon3},{icon:icon4},{icon:icon5},
           ],
          gjList:[
            {icon:gj1}, {icon:gj2}, {icon:gj3}, {icon:gj4}, {icon:gj5},
           ]
           
        }
    },
     created () {
  
    
    },
    mounted(){
         
    },
    methods:{
      
    },
    beforeDestroy(){
       
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/bn_bg2.png);
}
.grid_five{
    display: grid;
    grid-template-columns: 2fr 3fr 2fr;
   
    .item_group{
        .item_inner{
            .group_half{
               
                .half_text{
                    line-height: 2;
                }
            }
        }
        
    }
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
.ad_tab{
    font-size: 26px;
    padding:20px 0;
    transition: border 0.4s ease-in-out,color 0.4s ease-in-out;
    border-bottom:6px solid #E1E2E5;
    
}
.ad_tab_active{
     border-bottom:6px solid $theme_color3;
     color:$theme_color3;
}
.tab_container{
    background-image:url( ../../../public/bg/glbg.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    display: block;
}

.custom-scroll {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;;
    
}
.scroll-content {
    display: flex;
    animation: gridScroll 30s linear infinite;

}
.rescroll-content {
    display: flex;
    animation: gridReScroll 30s linear infinite;
}
.country{
    padding:6px 10px;
    background: #262D4C;
    border-radius: 21px 21px 21px 21px;
    border: 1px solid #003CFF;
    align-items: baseline;
    opacity: 0.9;
    
    >img{
        width: auto;
       
    }
    margin:0 10px;
}
.flex_item{
  width: 40px;
  height: 40px;
  position: relative;
  background: #272932;
  border-radius: 50%;

  >img{
    width:100%;
    height: 100%;
  }
}
.flex_item + .flex_item{
  margin-left:-12px;
}
@keyframes gridScroll {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}
@keyframes gridReScroll {
    0% {
        transform: translateX(-50%);
    }
    100% {
        transform: translateX(0);
    }
}

.zf_tab{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin:0 14px;
}



.po_img{
    // position: absolute;
    position: relative;
    z-index: 2;
    width:100%;
    height: auto;
    // padding-bottom:100px;
}
@media screen and (max-width:991px){
    .grid_five{
      grid-template-columns:1fr;
      .item_group{
        padding:0;
      }
      .item_inner{
        // display: flex;
        .group_half{
           
            padding:20px 10px;
        }
      }
    }
    .ad_tab{
        font-size: 14px;
    }
    .grid_sp_item{
      padding:0;
    }
}
</style>